<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent scrollable width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <v-icon>mdi-file-document-edit-outline</v-icon>                                                
                        <span>{{work.name}}の作業記録</span>
                    </v-list-item-title>
                    <TitleButton
                        v-if="canRecordWork && !isDeleteMode"
                        @click="onClickSave"
                        color="primary"
                        icon="mdi-floppy"
                        name="保存" />
                    <TitleButton
                        v-if="isDeleteMode"
                        @click="onClickDelete"
                        color="warning"
                        icon="mdi-delete"
                        name="削除" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="onClickClose" />
                </v-app-bar>
            </v-card-title>
            <v-card-text style="height:700px" class="pa-0">
                <v-sheet 
                    v-if="lastRecordUserInfo != null" 
                    outlined 
                    :class="'text-center ml-1 mr-1 mt-1 pa-1 '+($vuetify.breakpoint.xs ? 'caption' : '')"
                    color="cyan darken-1 white--text">
                    <v-icon color="white">mdi-information</v-icon>{{lastRecordUserInfo.dateTime}} に {{lastRecordUserInfo.userName}} さんから作業記録が行われました。
                </v-sheet>
                <v-container>
                    <v-row>
                        <v-col>
                            <DatePicker 
                                label="作業日"
                                dense
                                :canEdit="canRecordWork"
                                v-model="editItems.date"
                                :clearable="false"
                                :max="maxDate" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card outlined>
                                <v-card-text class="pa-0">
                                    <v-container fluid>
                                        <transition-group name="items" tag="ul">
                                            <template v-for="item in this.workType.recordItems">
                                                <v-row v-if="item.disabled == null || item.disabled == false" :key="item.recordNo" dense>
                                                    <v-col>
                                                        <table style="width:100%">
                                                            <tr>
                                                                <td style="width:100%">
                                                                    <ValueInputter
                                                                        v-model="editItems.values[item.recordNo]"
                                                                        :readonly="!canRecordWork"
                                                                        :item="item"
                                                                        :composts="composts"
                                                                        :fertilizeries="fertilizeries"
                                                                        :pesticides="pesticides"
                                                                        :targetPlace="place"
                                                                        :workDate="editItems.date"
                                                                        :isNewWorkRecord="targetRecord == null" />
                                                                </td>
                                                                <td v-if="item.recordNo > 100 && !isShareMode && !isSortMode">
                                                                    <v-menu offset-y>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn
                                                                                dark
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                color="primary"
                                                                                icon>
                                                                                <v-icon>mdi-menu</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <v-list dense>
                                                                            <v-list-item 
                                                                                v-for="menuItem in editItemMenuItems" :key="menuItem.type"
                                                                                @click="onSelectedRecordItemMenu(item, menuItem)">
                                                                                <v-list-item-icon><v-icon>{{menuItem.icon}}</v-icon></v-list-item-icon>
                                                                                <v-list-item-title>{{menuItem.text}}</v-list-item-title>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </td>
                                                                <template v-if="isSortMode && item.recordNo > 100">
                                                                    <td>
                                                                        <v-btn icon x-small color="primary" @click="changeRecordItemOrder(item, true)"><v-icon>mdi-arrow-up</v-icon></v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn icon x-small color="primary" @click="changeRecordItemOrder(item, false)"><v-icon>mdi-arrow-down</v-icon></v-btn>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </table>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </transition-group>
                                        <!-- <v-row v-if="canRecordWork">
                                            <v-col>
                                                <v-btn color="primary" @click="onClickNewRecordItem" ><v-icon>mdi-plus-circle-outline</v-icon>新しい作業記録項目を追加</v-btn>
                                            </v-col>
                                        </v-row> -->
                                    </v-container>
                                </v-card-text>
                            </v-card>
                            <v-card v-if="!isShareMode" outlined flat class="mt-1">
                                <div class="ma-2">
                                    <v-btn color="primary" @click="onClickNewRecordItem" class="ma-1"><v-icon>mdi-plus-circle-outline</v-icon>新しい作業記録項目を追加</v-btn>
                                    <v-btn :color="isSortMode ? 'red white--text' : 'primary'" @click="onClickSort" class="ma-1">
                                        <v-icon>mdi-sort-variant</v-icon>
                                        <span v-if="!isSortMode">順序変更</span>
                                        <span v-else>順序変更中</span>
                                    </v-btn>
                            <div 
                                v-if="isSortMode" 
                                class="red--text mt-1" 
                                :style="'text-align:center; '+($vuetify.breakpoint.xs ? 'font-size:x-small' : '')">
                                <v-icon color="red">mdi-alert</v-icon>順序変更終了後は、[順序変更中] を押して下さい。
                            </div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-textarea
                                v-model="editItems.memo"
                                label="メモ"
                                rows="2"
                                outlined
                                clearable
                                auto-grow
                                :readonly="!canRecordWork" />
                        </v-col>
                    </v-row>
                    <!-- 編集/表示兼用の画像一覧 -->
                    <v-row dense>
                        <!-- 取り込みボタンは共有時は、記録権限有りで有効, 削除ボタンは共有時は記録権限に関わらず無効 -->
                        <Images 
                            v-model="editItems.images" 
                            :enableImport="canRecordWork" 
                            :enableDelete="!isShareMode"
                            :enableImageComment="true"
                            @onCommentImage="onCommentImage" />
                    </v-row>
                </v-container>
                <!-- コメント -->
                <div v-if="targetRecord != null">
                    <v-divider class="mb-2" />
                    <div v-for="comment in comments" :key="comment.body.commentNo">
                        <div class="d-flex flex-no-wrap">
                            <v-avatar class="ml-2" rounded>
                                <v-img v-if="comment.writerInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                <v-img v-if="comment.writerInfo.avaterURL != null" :src="comment.writerInfo.avaterURL"/>
                            </v-avatar>
                            <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                <v-card-text class="pa-1">
                                    <div class="subtitle-2 font-weight-bold mb-1">{{comment.writerInfo.userName}}</div>
                                    <div class="body-2 mb-1" v-html="comment.body.comment.replace(/\r?\n/g, '<br>')" />
                                    <div class="caption text-right">{{comment.body.writer.dateTime}}</div>
                                </v-card-text>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-no-wrap" v-if="!isDeleteMode">
                        <v-avatar class="ml-2 mt-2" rounded>
                            <v-img v-if="loggedInUserData.avaterImage != null" :src="loggedInUserData.avaterImage.url" />
                            <v-img v-if="loggedInUserData.avaterImage == null" src="@/assets/no_avater_image.png"/>
                        </v-avatar>
                        <!-- <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%"> -->
                        <v-textarea
                            v-model="comment"
                            label="コメント"
                            rows="2"
                            clearable
                            solo
                            flat
                            auto-grow
                            hide-details
                            dense
                            class="mt-2 balloon2-left mr-2"
                            :append-icon="comment != null && comment.trim().length > 0 ? 'mdi-send' : ''"
                            @click:append="onClickSendNewComment">
                        </v-textarea>
                            <!-- <v-btn color="primary" @click="onClickSendNewComment" :disabled="comment.trim().length == 0" class="mt-1 mb-1">投稿する</v-btn> -->
                        <!-- </div> -->
                    </div>
                </div>
            </v-card-text>
        </v-card>                
        <WorkItemMaintenance ref="workItemMaintenance" :workType="workType" @onAddNewRecordItem="onAddNewRecordItem"/>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import DatePicker from '@/components/tools/DatePicker';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import Confirm from '@/components/tools/ConfirmDialog';
    import CategoryItemSelector from '@/components/tools/CategoryItemSelector';
    import ValueInputter from '@/components/place/PlaceWorkRecordValueInputter';
    import WorkItemMaintenance from '@/components/place/MaintenancePlaceWorkRecordItem';
    import Images from '@/components/tools/Images';

    export default {
        components: {
            Title,
            TitleButton,
            DatePicker,
            NumInput,
            Confirm,
            CategoryItemSelector,
            ValueInputter,
            WorkItemMaintenance,
            Images
        },
        data: function () {
            return {
                /**
                 * ダイアログを表示する時は、True
                 */
                isView: false,
                /**
                 * 場所
                 */
                place: null,
                /**
                 * 登録されている全作業項目
                 */
                workTypes: null,
                /**
                 * 登録されている全堆肥
                 */
                composts: null,
                /**
                 * 登録されている全肥料
                 */
                fertilizeries: null,
                /**
                 * 登録されている全農薬
                 */
                pesticides: null,
                /**
                 * 作業
                 */
                work: null,
                /**
                 * 編集対象の作業記録(新規の時は、null)
                 */
                targetRecord: null,
                /**
                 * 編集対象の作業記録のコピー
                 * (※新しいインスタンスになる)
                 * (※保存時にこの画面を開いた時の値と新しい入力とを比較したい時に使用する)
                 */
                beforeChangeRecord: null,
                /**
                 * 作業に設定されている作業種類
                 */
                workType: null,
                /** 編集項目 */
                editItems: {
                    date: null,
                    memo: null,
                    values: [],
                    images: []
                },
                /**
                 * 編集項目のメニュー(recordNo>=101のユーザーが追加した記録項目に対する操作)
                 */
                editItemMenuItems: [
                    {icon: "mdi-pencil-outline", type: "edit", text: "項目編集"},
                    {icon: "mdi-content-copy", type: "copy", text: "項目コピー"},
                    {icon: "mdi-delete", type: "delete", text: "項目削除"},
                ],
                /** 指定可能な最大の作業日 */
                maxDate: (new Date()).toFormatString("yyyy-MM-dd"),
                /** 作業記録に設定されている全コメント */
                comments: [],
                /** コメント */
                comment: "",
                /** 削除モード */
                isDeleteMode: false,
                /** 並び替えモード */
                isSortMode: false,
                /** 並び替えモードに入る時の作業データ */
                sortModePreStartWorkType: null,
                /** 記録項目毎の編集前の値のコピーを格納する配列 */
                beforeRecordsValues: [],
                /** 最後にこの作業記録を行ったユーザー情報(自身の時は、null) */
                lastRecordUserInfo: null
            }
        },
        watch: {
            editItems: {
                handler: function (value, old) {
                    console.log("editItems changed", value)
                },
                deep: true
            }
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * 共有モード
             */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /**
             * 共有モードの全種類
             */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
            /**
             * 作業記録を行えるか否か
             */
            canRecordWork: function () {
                if (this.isDeleteMode) return false
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.place.body, ["browse", "work", "work.record"])
                return this.checkAuthority(["browse", "work", "work.record"])
            },
            /**
             * 指定された権限を全て持つか否かを返す(共有中ではない時は、必ず True。共有中はチェック結果を返す)
             */
            checkAuthority: function () {
                return function (authorities) {
                    const self = this
                    if (!self.isShareMode) {
                        return true
                    }

                    if (self.place.authorities == null) {
                        return false
                    }

                    const groupAuthorities = self.place.authorities.find((v)=>v.ownerUserUID == self.shareUserGroupMyUserData.ownerUserUID && v.groupNo == self.shareUserGroupMyUserData.groupNo)
                    const userAuthorities = groupAuthorities != null ? groupAuthorities.users[self.loggedInUserUID] : null

                    // console.log("checkAuthority", place, this.shareUserGroupMyUserData, this.loggedInUserUID, groupAuthorities, userAuthorities)

                    if (userAuthorities != null) {
                        for (var authority of authorities) {
                            if (userAuthorities.findIndex((v)=>v == authority) < 0) {
                                console.log("user authority", authority, "deny!!")
                                return false
                            }
                            console.log("user authority", authority, "allow!!")
                        }
                        console.log("user authority", "all allow!!", authorities, userAuthorities)
                        return true
                    }

                    if (self.mi_checkGroupUserAuthority(self.place.body, authorities)){
                        return true
                    }
                    return false
                }
            },
        },
        methods: {
            /**
             * 追加された作業記録項目のメニュー項目選択時
             */
            onSelectedRecordItemMenu: function (recordItem, menuItem) {
                const self = this
                switch (menuItem.type) {
                    case "edit":
                        this.$refs.workItemMaintenance.show(this.place, this.workType, recordItem)
                        break;
                    case "delete":
                        this.$refs.confirm.show({
                            title: "作業記録項目の削除",
                            message: "この作業記録項目を削除しますか？<br/>※削除された作業記録項目は、元に戻す事は出来ません。",
                            icon: "mdi-alert",
                            buttonYes: "削除する",
                            buttonNo: "いいえ",
                            width: 450,
                            listenerYes: function () {
                                self.deleteRecordItem(recordItem)
                                return true
                            },
                        })
                        break;
                    case "copy":
                        console.log("copy", recordItem)
                        const newRecordItem = JSON.parse(JSON.stringify(recordItem))
                        this.$refs.workItemMaintenance.show(this.place, this.workType, newRecordItem, true)
                        break;
                }
            },
            /**
             * 新しい作業記録項目の追加ボタン押下時
             */
            onClickNewRecordItem: function () {
                this.$refs.workItemMaintenance.show(this.place, this.workType)
            },
            /**
             * 並び替えボタン押下時
             */
            onClickSort: function () {
                
                const self = this

                try {
                    if (this.isSortMode) {
                        // 現在、並び替えモードの時
                        const changedRecordItems = []
                        const preWorkType = JSON.parse(this.sortModePreStartWorkType)
                        for (var i=0; i<preWorkType.recordItems.length; i++) {
                            const currentRecord = this.workType.recordItems.find((v)=>v.recordNo == preWorkType.recordItems[i].recordNo)
                            if (currentRecord.orderNo != preWorkType.recordItems[i].orderNo) {
                                changedRecordItems.push(currentRecord)
                                console.log("changed record item", currentRecord, preWorkType.recordItems[i].orderNo, "=>", currentRecord.orderNo)
                            }
                        }
                        if (changedRecordItems.length > 0) {
                            const batch = db.batch()
                            changedRecordItems.forEach(function(item, index){
                                const docRecordItem = db.collection("users").doc(self.userUID)
                                .collection("places").doc(self.place.body.placeID+"")
                                .collection("place_work_types").doc(self.workType.workTypeID+"")
                                .collection("record_items").doc(item.recordNo+"")
                                
                                batch.update(
                                    docRecordItem, {"orderNo": item.orderNo}
                                )
                                if (index == changedRecordItems.length-1) {
                                    batch.commit().then(function(){
                                        self.$store.commit("notification", {message:"作業記録項目を更新しました。", isError:false})
                                    }).catch (function (error) {
                                        console.log(error)
                                        self.$store.commit("notification", {message:"作業記録項目の更新に失敗しました。("+error+")", isError:true})
                                        self.mi_writeLog("RecorderPlaceWork/onClickSort", "作業記録項目の更新に失敗しました。("+error+")")
                                    })
                                }
                            })
                        }
                        this.isSortMode = false
                    } else {
                        // 現在、並び替えモード解除の時
                        // 現在の作業種類の内容をJSON形式の文字列で退避(解除時に、並びが変わった記録項目のみを更新させる為)
                        this.sortModePreStartWorkType = JSON.stringify(this.workType)
                        this.isSortMode = true
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            /**
             * 閉じるボタン押下時
             */
            onClickClose: function () {
                if (this.isSortMode) {
                    this.$refs.confirm.show({
                        title: "順序変更中",
                        message: "順序を変更中です。<br/>[順序変更中] ボタンを押して順序変更を終了させて下さい。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 400,
                    })
                    return
                }
                this.isView = false
            },
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this

                if (this.isSortMode) {
                    this.$refs.confirm.show({
                        title: "順序変更中",
                        message: "順序を変更中です。<br/>[順序変更中] ボタンを押して順序変更を終了させて下さい。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 400,
                    })
                    return
                }

                console.log(this.editItems)

                this.$refs.confirm.show({
                    title: "作業記録の登録",
                    message: "作業記録を登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.mi_writeLog("RecorderPlaceWork/onClickSave", "start")
                        self.$store.commit("processing", {start:true, message:"作業記録を保存しています…。"})
                        if (self.editItems.images.length > 0) {
                            /** 画像がある時は、その処理を行った後に更新処理を呼び出し */
                            self.imageUploader(self.updateWork)
                        } else {
                            /** 画像がない時は、更新処理 */
                            self.updateWork()
                        }
                        return true
                    },
                })
            },
            /**
             * 作業記録の削除ボタン押下時
             */
            onClickDelete: function () {
                const self = this
                console.log(this.editItems)
                this.$refs.confirm.show({
                    title: "作業記録の削除",
                    message: "この作業記録を削除しますか？<br/>※削除された作業記録は、元に戻す事は出来ません。",
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "いいえ",
                    width: 450,
                    listenerYes: function () {
                        self.deleteWorkRecord()
                        return true
                    },
                })
            },
            /**
             * コメント投稿ボタン押下時
             */
            onClickSendNewComment: function () {
                const self = this

                const comment = {
                    commentNo: this.targetRecord.comments.length == 0 ? 1 : this.targetRecord.comments.length + 1,
                    comment: this.comment,
                    writer: {
                        userUID: this.loggedInUserUID,
                        dateTime: this.df_currentDateTime()
                    }
                }        
                const commentData = {
                    body: comment,
                    writerInfo: {
                        userName: this.loggedInUserData.userName,
                        avaterURL: this.loggedInUserData.avaterImage != null ? this.loggedInUserData.avaterImage.url : null
                    }
                }

                this.targetRecord.comments.push(comment)
                this.comments.push(commentData)

                this.comment = null

                // 通知送信を行うファンクション
                const notificationSender = function () {
                    const notificationParams = {
                        to: {
                            userUID: self.userUID
                        },
                        sender: null,
                        content: {
                            type: 20,
                            title: "新着コメント",
                            message: "あなたの圃場 ["+self.place.body.name+"] の作業 ["+self.work.name+"] の作業記録に、新しいコメントが投稿されました。"
                        },
                        data: {
                            target: 3,
                            targetKey: {
                                placeID: self.work.placeID,
                                workID: self.work.workID,
                                recordDateTime: self.targetRecord.dateTime
                            },
                        }                        
                    }
                    self.$store.commit("sendNotification", notificationParams)
                }

                // 場所作業を更新
                db.collection("users").doc(this.userUID)
                .collection("places").doc(""+this.work.placeID)
                .collection("works").doc(this.work.workID).set(this.work).then(function(){
                    self.$store.commit("notification", {message:"コメントを投稿しました。", isError:false})
                    if (self.isShareMode) {
                        notificationSender()
                    }
                }).catch (function (error) {
                    self.$store.commit("notification", {message:"コメントの投稿に失敗しました。", isError:true})
                    self.mi_writeLog("RecorderPlaceWork/onClickSendNewComment", "コメントの投稿に失敗しました。("+error+")")
                    console.log(error)
                })

                console.log(comment, commentData, this.work)
            },
            /**
             * 画像へのコメントが行われた時
             */
            onCommentImage: function (image) {
                console.log("RecorderPlaceWork", "onCommentImage", image, this.targetRecord)

                const self = this
                
                if (this.targetRecord == null) {
                    console.log("新しい作業記録なので、保存処理は行わない")
                    return
                }

                const targetImage = this.targetRecord.images.find((v)=>v.capturedDate == image.capturedDate)
                console.log("画像の保存処理を実行する", "editImage=", this.editItems, "targetImage=", targetImage)

                // var newComment = null
                // for (var i=0; i<image.comments.length; i++) {
                //     const comment = image.comments[i]
                //     const registeredCommentIndex = targetImage.comments.find((v)=>v.dateTime == comment.dateTime)
                //     if (registeredCommentIndex < 0) {
                //         // 新しいコメント
                //         newComment = {
                //             version: "1.0.0",
                //             image: image.comments[i].image,
                //             url: null,
                //             visible: image.comments[i].visible,
                //             dateTime: image.comments[i].dateTime,
                //             userUID: this.userUID
                //         }
                //         targetImage.comments.push(newComment)
                //     } else {
                //         // 既に配列内に記録されているコメントの時は、非表示か否かをセット
                //         targetImage.comments[registeredCommentIndex].visible = comment.visible
                //     }
                // }

                // if (newComment != null) {
                //     const filename = 
                // }


                // const filename = image.capturedDate.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
                //     const uploadUrl = "images/users/" + self.userUID + "/places/" + self.work.placeID + "/works/" + self.work.workID + "/" + filename
                    
                //     console.log(uploadUrl)

                //     var storage = fb.storage().ref()
                //     var outputRef = storage.child(uploadUrl)

                //     switch (image.state) {
                //         case 1:
                //             // ===============================
                //             // 登録済みの画像
                //             uploadedNum++
                //             if (uploadedNum == self.editItems.images.length) {
                //                 completed()
                //             }
                //             break;
                //         case 2:
                //         case 4:
                //             // ===============================
                //             // 画像のアップロード
                //             const startIndex = image.image.indexOf(",") + 1
                //             outputRef.putString(image.image.substring(startIndex), 'base64').then(function(snapShot){
                //                 snapShot.ref.getDownloadURL().then (function(url){
                //                     console.log("imageUploader", "upload success("+image.no+")", "download url", url)
                //                     image.url = url
                //                     uploadedNum++
                //                     if (uploadedNum == self.editItems.images.length) {
                //                         completed()
                //                     }
                //                 }).catch(function(error){
                //                     console.log("画像のURL取得失敗", error)
                //                 })
                //             }).catch(function(error){
                //                 console.log("画像のアップロード失敗", error)
                //             })
                //             break;
                //         case 3:
                //             // =======================================
                //             // 画像の削除
                //             outputRef.delete().then(function (){
                //                 console.log("RegisterObservation", "delete success("+image.no+")")
                //                 uploadedNum++
                //                 if (uploadedNum == self.editItems.images.length) {
                //                     completed()
                //                 }
                //             }).catch(function(error){
                //                 console.log("画像の削除失敗", error)
                //             })
                //             break;
                //     }

                targetImage.comments = []
                for (var i=0; i<image.comments.length; i++) {
                    targetImage.comments.push(
                        {
                            version: "1.0.0",
                            image: image.comments[i].image,
                            visible: image.comments[i].visible,
                            dateTime: image.comments[i].dateTime,
                            userUID: this.userUID
                        }
                    )
                }

                const recordIndex = this.work.records.findIndex((v)=>v.dateTime == this.targetRecord.dateTime)
                const imageIndex = this.work.records[recordIndex].images.findIndex((v)=>v.capturedDate == image.capturedDate)
                const docWork = db.collection("users").doc(this.userUID)
                .collection("places").doc(""+this.work.placeID)
                .collection("works").doc(this.work.workID)

                docWork.get().then(function(doc) {
                    const work = doc.data()
                    work.records[recordIndex].images[imageIndex].comments = targetImage.comments
                    docWork.set(work).then(function(){
                        self.$store.commit("notification", {message:"画像コメントを登録しました。", isError:false})
                        if (self.isShareMode) {
                            const notificationParams = {
                                to: {
                                    userUID: self.userUID
                                },
                                sender: null,
                                content: {
                                    type: 20,
                                    title: "新着画像コメント",
                                    message: "あなたの圃場["+self.place.body.name+"]の作業["+self.work.name+"]の作業記録に、新しい画像コメントが投稿されました。"
                                },
                                data: {
                                    target: 3,
                                    targetKey: {
                                        placeID: self.work.placeID,
                                        workID: self.work.workID,
                                        recordDateTime: self.targetRecord.dateTime
                                    },
                                }                        
                            }
                            self.$store.commit("sendNotification", notificationParams)
                        }
                    }).catch (function (error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"画像コメントの登録に失敗しました。("+error+")", isError:true})
                        self.mi_writeLog("RecorderPlaceWork/onCommentImage", "画像コメントの登録に失敗しました。(1)("+error+")")
                    })
                }).catch (function(error) {
                    self.$store.commit("notification", {message:"画像コメントの登録に失敗しました。("+error+")", isError:true})
                    self.mi_writeLog("RecorderPlaceWork/onCommentImage", "画像コメントの登録に失敗しました。(2)("+error+")")
                })
            },
            /**
             * 新しい作業記録項目が作成された時
             */
            onAddNewRecordItem: function (newRecordItem) {
                const value = this.getRecordItemInitialValue(newRecordItem)
                this.editItems.values[newRecordItem.recordNo] = value
            },
            /**
             * 指定された記録項目の初期値を返す
             */
            getRecordItemInitialValue: function (recordItem) {
                var initialEditValue = null
                switch (recordItem.type) {
                    case 1:     // 数値
                        initialEditValue = 0
                        break
                    case 2:     // 文字列
                    case 3:     // 日付
                    case 4:     // 時刻
                        initialEditValue = ""
                        break
                    case 10:    // 農薬
                        initialEditValue = []
                        break
                    case 11:    // 出荷と販売
                        initialEditValue = {
                            shipment: 0,
                            sales: 0
                        }
                        break
                    case 12:    // 病気
                        initialEditValue = {
                            sickNo: null,
                            sickName: null
                        }
                        break
                    case 13:    // 害虫
                        initialEditValue = {
                            verminNo: null,
                            verminName: null
                        }
                        break
                }
                return initialEditValue
            },
            /**
             * 指定された作業記録項目の順序を変更する
             * isUp=Trueの時は、上に移動。 =Falseの時は、下に移動
             */
            changeRecordItemOrder: function (recordItem, isUp) {

                // console.log("changeRecordItemOrder", recordItem, isUp)

                // 対象項目の配列内のインデックス
                const currentIndex = this.workType.recordItems.findIndex((v)=>v.recordNo == recordItem.recordNo)

                // console.log("changeRecordItemOrder", "currentIndex", currentIndex)

                // 入れ替え対象項目の配列内のインデックス(※入れ替え対象項目は、記録No.が 100 より大きいもののみ)
                var swapItemIndex = -1
                
                if (isUp) {
                    if (currentIndex == 0) {
                        return
                    }
                    for (var i=currentIndex-1; i>=0; i--) {
                        const item = this.workType.recordItems[i]
                        if (!item.disabled && item.recordNo > 100) {
                            swapItemIndex = i
                            break
                        }
                    }
                } else {
                    if (currentIndex == this.workType.recordItems.length - 1) {
                        return
                    }
                    for (var i=currentIndex+1; i<this.workType.recordItems.length; i++) {
                        const item = this.workType.recordItems[i]
                        if (!item.disabled && item.recordNo > 100) {
                            swapItemIndex = i
                            break
                        }
                    }
                }

                // console.log("changeRecordItemOrder", currentIndex, swapItemIndex)

                if (swapItemIndex < 0) {
                    return
                }

                // orderNoを入れ替え
                const workOrderNo = recordItem.orderNo
                recordItem.orderNo = this.workType.recordItems[swapItemIndex].orderNo
                this.workType.recordItems[swapItemIndex].orderNo = workOrderNo

                // 全体を並び替え
                this.sortRecordItems()
             },
            /**
             * 作業記録項目の削除
             */
            deleteRecordItem: function (recordItem) {
                console.log(recordItem)
                const self = this
                try {
                    db.collection("users").doc(this.userUID)
                    .collection("places").doc(this.place.body.placeID+"")
                    .collection("place_work_types").doc(this.workType.workTypeID+"")
                    .collection("record_items").doc(recordItem.recordNo+"")
                    .update(
                        {
                            "disabled": true
                        }
                    ).then(function(){
                        self.$set(recordItem, "disabled", true)
                        self.$store.commit("notification", {message:"作業記録項目を削除しました。", isError:false})
                    }).catch (function(error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"作業記録項目の削除に失敗しました。("+error+")", isError:true})
                        self.mi_writeLog("RecorderPlaceWork/deleteRecordItem", "作業記録項目の削除に失敗しました。("+error+")")
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            /**
             * 作業に作業記録をセットして更新
             */
            updateWork: function () {

                this.mi_writeLog("RecorderPlaceWork/updateWork", "start")

                const self = this

                /**
                 * 作業にセットする作業記録を作成
                 */
                var record = this.targetRecord
                var isNewRecord = false

                if (record == null) {
                    record = {
                        date: "",
                        dateTime: this.df_currentDateTime(),
                        values: [],
                        memo: "",
                        images: []
                    }
                    isNewRecord = true
                }

                if (record.recorders == null) {
                    record.recorders = []
                }

                // 記録者
                record.recorders.push(
                    {
                        userUID: this.loggedInUserUID,
                        dateTime: this.df_currentDateTime()
                    }
                )

                record.date = this.editItems.date
                // record.dateTime = this.df_currentDateTime()
                record.memo = this.editItems.memo
                record.values = []

                for (var i=0; i<this.editItems.values.length; i++) {
                    if (this.editItems.values[i] != null) {
                        record.values.push(
                            {
                                recordNo: i,
                                value: this.editItems.values[i]
                            }
                        )
                    }
                }

                this.work.updater = {
                    userUID: self.userUID,
                    dateTime: this.df_currentDateTime()
                }

                if (this.work.recordInformation.firstDate == null || this.work.recordInformation.firstDate == "" || this.work.recordInformation.firstDate > this.editItems.date) {
                    this.work.recordInformation.firstDate = this.editItems.date
                }

                if (this.work.recordInformation.lastDate == null || this.work.recordInformation.lastDate == "" || this.work.recordInformation.lastDate < this.editItems.date) {
                    this.work.recordInformation.lastDate = this.editItems.date
                }

                if (this.work.records == null) {
                    this.work.records = []
                }

                /**
                 * 画像を作業記録に設定
                 */
                record.images = []

                for(var i=0; i<this.editItems.images.length; i++) {
                    const editImage = this.editItems.images[i]
                    switch(editImage.state) {
                        case 1:
                        case 2:
                        case 4:
                            const imageData = {
                                version: "1.0.0",
                                url: editImage.url,
                                capturedDate: editImage.capturedDate,
                                comments: []
                            }
                            record.images.push(imageData)
                            if (editImage.comments != null) {
                                for (var j=0; j<editImage.comments.length; j++) {
                                    const comment = editImage.comments[j]
                                    imageData.comments.push({
                                        version: "1.0.0",
                                        image: comment.image,
                                        visible: comment.visible,
                                        dateTime: comment.dateTime,
                                        userUID: this.userUID
                                    })
                                }
                            }
                            break;
                        case 3:
                            break;
                    }
                }

                /**
                 * 新規作業記録の時は、作業に追加
                 */
                if (isNewRecord) {
                    this.work.records.push(record)
                }

                this.work.records.sort(function(x, y) {
                    if (x.date > y.date) {
                        return 1
                    }
                    if (x.date < y.date) {
                        return -1
                    }
                    if (x.dateTime > y.dateTime) {
                        return 1
                    }
                    if (x.dateTime < y.dateTime) {
                        return -1
                    }
                    return 0
                })

                console.log("保存する作業", this.work, this.work.workTypeID, this.place.body.managementAgrichemical)
                
                // this.updateAgrichemicalUseHistory(record)  // !!!!!!!!!!!!!!!!!!!!

                // return  // !!!!!!!!!!!!!!!!!!

                /**
                 * 登録処理
                 */
                db.collection("users").doc(this.userUID).collection("places").doc(""+this.work.placeID).collection("works").doc(this.work.workID)
                .set(this.work).then(function() {
                    self.mi_writeLog("RecorderPlaceWork/updateWork", "作業記録を登録しました。")
                    self.$store.commit("notification", {message:"作業記録を登録しました。", isError:false})
                    self.$store.commit("processing")

                    // 通知送信を行うファンクション
                    const notificationSender = function () {
                        const notificationParams = {
                            to: {
                                userUID: self.userUID
                            },
                            sender: null,
                            content: {
                                type: 30,
                                title: "作業記録",
                                message: "あなたの圃場 ["+self.place.body.name+"] の作業 ["+self.work.name+"] に ["+self.loggedInUserData.userName+"] さんが作業記録を行いました。"
                            },
                            data: {
                                target: 3,
                                targetKey: {
                                    placeID: self.work.placeID,
                                    workID: self.work.workID,
                                    recordDateTime: record.dateTime
                                },
                            }                        
                        }
                        self.$store.commit("sendNotification", notificationParams)
                    }

                    if (self.loggedInUserUID != self.userUID) {
                        notificationSender()
                    }

                    /**
                     * 作業毎の特殊処理
                     */
                    switch (self.work.workTypeID) {
                        case 8:
                            /** 
                             * 農薬使用作業の時は、農薬使用履歴を記録する。
                             */
                            if (self.place.body.managementAgrichemical.enabled) {
                                self.updateAgrichemicalUseHistory(record)
                            }
                            break;
                    }
                    /**
                     * 未分類から画像を取り込んだ時は、その画像を未分類から削除する
                     */
                    self.editItems.images.forEach(function(image){
                        if (image.state == 4) {
                            // ストレージから画像を削除
                            var storage = fb.storage().ref()
                            var outputRef = storage.child("images/users/"+self.userUID+"/uncategorized_images/"+image.source.imageID)
                            outputRef.delete().then(function(){
                                // ストレージから画像を削除後、DBから削除
                                db.collection("users").doc(self.userUID).collection("uncategorized_images").doc(image.source.imageID).delete().then(function(){
                                    console.log("uncategorized image deleted")
                                }).catch (function(error){
                                    console.log("uncategorized image delete failed!!(DB)", error)
                                    self.mi_writeLog("RecorderPlaceWork/updateWork", "未分類画像の削除に失敗しました。(DB)("+error+")")
                                })
                            }).catch(function (error) {
                                console.log("uncategorized image delete failed!!(Storage)", error)
                                self.mi_writeLog("RecorderPlaceWork/updateWork", "未分類画像の削除に失敗しました。(Storage)("+error+")")
                            })
                        }
                    })

                    self.isView = false
                }).catch (function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"作業記録の登録に失敗しました。", isError:true})
                    self.$store.commit("processing")
                    self.mi_writeLog("RecorderPlaceWork/updateWork", "作業記録の登録に失敗しました。("+error+")")
                })

            },
            /**
             * 作業記録を削除
             */
            deleteWorkRecord: function () {

                const self = this

                // 作業から対象作業記録を削除して、データベースの作業を更新
                const recordIndex = this.work.records.findIndex((v)=>v.date == this.targetRecord.date && v.dateTime == this.targetRecord.dateTime)
                this.work.records.splice(recordIndex, 1)

                db.collection("users").doc(this.userUID).collection("places").doc(""+this.work.placeID).collection("works").doc(this.work.workID)
                .set(this.work).then(function() {
                    
                    self.$store.commit("notification", {message:"作業記録を削除しました。", isError:false})

                    /**
                     * 作業毎の特殊処理
                     */
                    switch (self.work.workTypeID) {
                        case 8:
                            /** 
                             * 農薬使用作業の時は、農薬使用履歴を削除する。
                             */
                            if (self.place.body.managementAgrichemical.enabled) {
                                self.updateAgrichemicalUseHistory(self.targetRecord, true)
                            }
                            break;
                    }

                    /**
                     * 画像を持っている場合は、ストレージからその画像を削除
                     */
                    if (self.targetRecord.images != null && self.targetRecord.images.length > 0) {
                        
                        var storage = fb.storage().ref()

                        self.targetRecord.images.forEach(function(image) {
                            const filename = (new Date(image.capturedDate)).toFormatString("yyyyMMddHHmmss")
                            var outputRef = storage.child("images/users/"+self.userUID+"/places/"+self.place.body.placeID+"/works/"+self.work.workID+"/"+filename)
                            outputRef.delete().then(function(){
                                console.log("RecorderPlaceWork", "delete work record image success", image)
                            }).catch (function (error) {
                                self.mi_writeLog("RecorderPlaceWork/deleteWorkRecord", "作業記録の画像の削除に失敗しました。("+error+")")
                                console.log("RecorderPlaceWork", "delete work record image failed", image, error)
                            })
                        })
                    }

                }).catch (function (error) {
                    self.mi_writeLog("RecorderPlaceWork/deleteWorkRecord", "作業記録の削除に失敗しました。("+error+")")
                    console.log("RecorderPlaceWork", "delete work record failed", error)
                })

                this.isView = false
            },
            /**
             * 農薬使用履歴を更新
             */
            updateAgrichemicalUseHistory: function (record, isDeleteOnly) {

                const self = this

                if (isDeleteOnly == null) isDeleteOnly = false
                
                const workType = this.getWorkType(this.work.workTypeID)

                try{
                    // 作業記録の変更時は、作業前の農薬の履歴データを削除する
                    if (this.beforeChangeRecord != null) {

                        for (var i=0; i<this.beforeChangeRecord.values.length; i++) {
                            const value = this.beforeChangeRecord.values[i]
                            // 作業から、農薬散布の作業に対して処理を行う
                            const workTypeItem = workType.recordItems.find((v)=>v.recordNo == value.recordNo)

                            if (workTypeItem.type == 10) {

                                // 場所が持つ全農薬から、散布した農薬が持つ履歴から削除
                                for (var j=0; j<value.value.length; j++) {

                                    const usedAgrichemical = value.value[j]

                                    // 農薬の履歴データ
                                    var agrichemicalHistory = self.place.agrichemicalsHistory.agrichemicals[usedAgrichemical.agrichemicalNo]

                                    // 履歴データが存在する時は、その履歴データから作業記録に該当する履歴を削除
                                    if (agrichemicalHistory != null) {
                                        console.log("RecorderPlaceWork", "updateAgrichemicalUseHistory", "history delete data", this.beforeChangeRecord.date, this.work.workID, this.beforeChangeRecord.dateTime, agrichemicalHistory)
                                        const targetIndex = agrichemicalHistory.histories.findIndex(
                                            function (v) {
                                                return v.date == self.beforeChangeRecord.date && v.workID == self.work.workID && v.dateTime == self.beforeChangeRecord.dateTime
                                            }  
                                        )

                                        if (targetIndex >= 0) {
                                            agrichemicalHistory.histories.splice(targetIndex, 1)
                                        } else {
                                            console.log("RecorderPlaceWork", "history delete data none!!!")
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (isDeleteOnly == false) {
                        // 今回セットされた農薬の履歴をセット
                        for (var i=0; i<record.values.length; i++) {
                            const value = record.values[i]
                            // 作業から、農薬散布の作業に対して処理を行う
                            const workTypeItem = workType.recordItems.find((v)=>v.recordNo == value.recordNo)

                            if (workTypeItem.type == 10) {

                                // 場所が持つ全農薬から、散布した農薬が持つ履歴に追加
                                value.value.forEach(function(usedAgrichemical) {

                                    var agrichemicalHistory = self.place.agrichemicalsHistory.agrichemicals[usedAgrichemical.agrichemicalNo]

                                    if (agrichemicalHistory == null) {
                                        agrichemicalHistory = {
                                            histories: []
                                        }
                                        self.place.agrichemicalsHistory.agrichemicals[usedAgrichemical.agrichemicalNo] = agrichemicalHistory
                                        console.log("RecorderPlaceWork", "updateAgrichemicalUseHistory", "agrichemical new history created")
                                    }

                                    const history = {
                                        date: record.date,
                                        workID: self.work.workID,
                                        dateTime: record.dateTime
                                    }

                                    agrichemicalHistory.histories.push(history)
                                    console.log("RecorderPlaceWork", "updateAgrichemicalUseHistory", "agrichemical history set", history)
                                })
                            }
                        }
                    } else {
                        console.log("RecorderPlaceWork", "updateAgrichemicalUseHistory", "delete only mode")
                    }

                } catch (error) {
                    console.log("updateAgrichemicalUseHistory failed", error)
                    return
                }

                const docTarget = db.collection("users").doc(this.userUID)
                .collection("places").doc(this.place.body.placeID+"")
                .collection("agrichemical_histories").doc(this.place.body.managementAgrichemical.target+"")
                
                docTarget.set(this.place.agrichemicalsHistory).then(function(){
                    console.log("農薬使用履歴登録成功", self.place.agrichemicalsHistory)
                    self.$store.commit("notification", {message:"農薬の使用履歴を登録しました。", isError:false})
                }).catch(function(error){
                    console.log("農薬使用履歴登録失敗", self.place.agrichemicalsHistory, error)
                    self.$store.commit("notification", {message:"農薬の使用履歴の登録に失敗しました。", isError:true})
                    self.mi_writeLog("RecorderPlaceWork/updateAgrichemicalUseHistory", "農薬の使用履歴の登録に失敗しました。("+error+")")
                })
            },
            /**
             * 画像をアップロードもしくは削除
             * @param completed 処理終了後に呼び出すコールバック先
             */
            imageUploader: function (completed) {
                
                this.mi_writeLog("RecorderPlaceWork/imageUploader", "start")

                const self = this

                var uploadedNum = 0

                this.editItems.images.forEach(function(image){

                    const filename = image.capturedDate.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
                    const uploadUrl = "images/users/" + self.userUID + "/places/" + self.work.placeID + "/works/" + self.work.workID + "/" + filename
                    
                    console.log(uploadUrl)

                    var storage = fb.storage().ref()
                    var outputRef = storage.child(uploadUrl)

                    switch (image.state) {
                        case 1:
                            // ===============================
                            // 登録済みの画像
                            uploadedNum++
                            if (uploadedNum == self.editItems.images.length) {
                                completed()
                            }
                            break;
                        case 2:
                        case 4:
                            // ===============================
                            // 画像のアップロード
                            const startIndex = image.image.indexOf(",") + 1
                            outputRef.putString(image.image.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    console.log("imageUploader", "upload success("+image.no+")", "download url", url)
                                    image.url = url
                                    uploadedNum++
                                    if (uploadedNum == self.editItems.images.length) {
                                        completed()
                                    }
                                }).catch(function(error){
                                    console.log("画像のURL取得失敗", error)
                                    self.mi_writeLog("RecorderPlaceWork/imageUploader", "画像のURL取得失敗("+error+")")
                                })
                            }).catch(function(error){
                                console.log("画像のアップロード失敗", error)
                                self.mi_writeLog("RecorderPlaceWork/imageUploader", "画像のアップロード失敗("+error+")")
                            })
                            break;
                        case 3:
                            // =======================================
                            // 画像の削除
                            outputRef.delete().then(function (){
                                console.log("RegisterObservation", "delete success("+image.no+")")
                                uploadedNum++
                                if (uploadedNum == self.editItems.images.length) {
                                    completed()
                                }
                            }).catch(function(error){
                                console.log("画像の削除失敗", error)
                                self.mi_writeLog("RecorderPlaceWork/imageUploader", "画像の削除失敗("+error+")")
                            })
                            break;
                    }
                })
            },
            /**
             * 作業記録項目を並び替え
             */
            sortRecordItems: function () {
                this.workType.recordItems.sort(function(x, y){
                    if (x.orderNo > y.orderNo) return 1
                    if (x.orderNo < y.orderNo) return -1
                    return 0
                })
            },
            /**
             * ダイアログ表示
             * workRecord=null の時は、新しい作業記録
             */
            show: function (place, workTypes, work, workRecord, isDeleteMode) {
                console.log("RecorderPlaceWork", "show", workRecord, isDeleteMode)

                const self = this

                this.place = place
                this.workTypes = workTypes
                this.work = work
                
                if (isDeleteMode != null) {
                    this.isDeleteMode = isDeleteMode
                    console.log("RecorderPlaceWork", "delete mode!!")
                } else {
                    this.isDeleteMode = false
                }

                this.isView = true
                this.comments = []
                this.workType = this.getWorkType(this.work.workTypeID)
                this.lastRecordUserInfo = null

                if (workRecord != null) {
                    // 編集開始時の値の完全なコピーを作る
                    // (※通常は必要ないが、農薬作業の時は履歴更新の際に必要となる)
                    this.beforeChangeRecord = JSON.parse(JSON.stringify(workRecord))
                    console.log(workRecord, this.beforeChangeRecord)
                } else {
                    this.beforeChangeRecord = null
                }

                if (workRecord == null) {
                    this.targetRecord = null
                    this.editItems = {
                        date: (new Date()).toFormatString("yyyy-MM-dd"),
                        memo: null,
                        values: [],
                        images: [],
                    }
                    this.workType.recordItems.forEach(function(item) {
                        self.editItems.values[item.recordNo] = self.getRecordItemInitialValue(item)
                    })
                } else {
                    if (workRecord.comments == null) {      // comments が未定義のレコード対策用
                        workRecord.comments = []
                    }
                    this.targetRecord = workRecord
                    this.editItems = {
                        date: workRecord.date,
                        memo: workRecord.memo,
                        values: [],
                        images: []
                    }
                    workRecord.comments.forEach(function(comment) {
                        const commentData = {
                            body: comment,
                            writerInfo: {
                                userName: "",
                                avaterURL: ""
                            }
                        }
                        self.comments.push(commentData)
                        self.mi_userData(commentData.body.writer.userUID, commentData.writerInfo)
                    })
                    
                    this.workType.recordItems.forEach(function(item){
                        self.editItems.values[item.recordNo] = self.getRecordItemInitialValue(item)     // 一旦初期値で配列を作成
                    })

                    workRecord.values.forEach(function(value){
                        // console.log("RecorderPlaceValue", "show", "record edit", value)
                        // self.editItems.values[value.recordNo] = value.value

                        if (value.value == null || value.value == "") {
                            console.log("RecorderPlaceWork", "show", "edit record", value)
                            const recordItem = self.workType.recordItems.find((v)=>v.recordNo == value.recordNo)
                            value.value = self.getRecordItemInitialValue(recordItem)
                        }

                        // 記録項目毎の値のコピーを編集値として設定する
                        // ※この時、一旦コピー値をグローバルの配列に入れて、その参照をセットしないと農薬管理においてリアクティブが働かない(何故(# ﾟДﾟ))
                        // self.editItems.values[value.recordNo] = JSON.parse(JSON.stringify(value.value)) ← これだと農薬管理においてリアクティブがうまくいかない
                        self.beforeRecordsValues.push(JSON.parse(JSON.stringify(value.value)))
                        self.editItems.values[value.recordNo] = self.beforeRecordsValues[self.beforeRecordsValues.length-1]//JSON.parse(JSON.stringify(value.value))
                    })

                    if ((!this.isShareMode && workRecord.recorders != null && workRecord.recorders[workRecord.recorders.length-1].userUID != this.loggedInUserUID) || 
                        (this.isShareMode && workRecord.recorders != null && workRecord.recorders[workRecord.recorders.length-1].userUID != this.userUID)) {
                        this.lastRecordUserInfo = {
                            userUID: workRecord.recorders[workRecord.recorders.length-1].userUID,
                            userName: "",
                            avaterURL: "",
                            dateTime: workRecord.recorders[workRecord.recorders.length-1].dateTime
                        }
                        this.mi_userData(this.lastRecordUserInfo.userUID, this.lastRecordUserInfo)
                    }
                    workRecord.images.forEach(function(image, index) {
                        const imageData = {
                            no: index+1,
                            state: 1,
                            image: "",
                            url: image.url,
                            capturedDate: image.capturedDate,
                            comments: []
                        }
                        self.editItems.images.push(imageData)
                        if (image.comments == null) {
                            image.comments = []
                        }
                        image.comments.forEach(function (comment) {
                            console.log(comment)
                            // imageData.comments.splice(0, 0, 
                            //     {
                            //         image: comment.image,
                            //         visible: comment.visible,
                            //         dateTime: comment.dateTime
                            //     }
                            // )
                            imageData.comments.push(
                                {
                                    image: comment.image,
                                    visible: comment.visible,
                                    dateTime: comment.dateTime,
                                    userUID: comment.userUID
                                }
                            )
                        })
                    })
                }                
            },
            /**
             * 指定された作業種類IDの作業種類を返す
             */
            getWorkType: function (workTypeID) {
                const index = this.workTypes.findIndex((v)=>v.workTypeID == workTypeID)
                console.log("RecorderPlaceWork", "getWorkType", workTypeID, this.workTypes, index)
                if (index <= 0) {
                    console.error("RecorderPlaceWork", "getWorkType", "worktype unknown", workTypeID)
                    return null
                }
                return this.workTypes[index]
            }
        }
    }
</script>

<style scoped>
    .balloon2-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 0px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #555;
        font-size: 16px;
        background: #FFF;
        border: solid 3px #555;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .balloon2-left:before {
        content: "";
        position: absolute;
        top: 24px;
        left: -22px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 12px solid #FFF;
        z-index: 2;
    }

    .balloon2-left:after {
        content: "";
        position: absolute;
        top: 24px;
        left: -28px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 14px solid #555;
        z-index: 1;
    }

    .balloon2-left p {
        margin: 0;
        padding: 0;
    }
    
ul {
    padding: 0px
}

.items-leave-active,
.items-enter-active {
    transition: opacity .5s, transform .5s ease;
}
.items-leave-to,
.items-enter {
    opacity: 0;
    transform: translateX(50px);
}
.items-leave,
.items-enter-to {
    opacity: 1;
}
.items-move {
    transition: transform .5s;
}    
</style>
